import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const renderFeatures = () => {
  let features = [];
  const items = [
    {
      name: "Integrations",
      icon: "plug",
      description: "Intergrated APIs allow contiuity in XR."
    },
    {
      name: "Marketing",
      icon: "heart",
      description: "Market with a purpose, gain retention."
    },
    {
      name: "Support",
      icon: "headphones",
      description: "We are here to keep things running smoothly."
    }
  ];

  items.forEach((f, i) => {
    features.push(
      <li className="list-item" key={i}>
        <div className="media align-items-center">
          <div className="icon-shape mr-3">
            <div className="shape shape-pipes" />
            <FontAwesomeIcon
              icon={["fas", f.icon]}
              className="icon fa-3x text-alternate"
            />
          </div>

          <div className="media-body">
            <h5 className="bold">{f.name}</h5>
            <p className="my-0">{f.description}</p>
          </div>
        </div>
      </li>
    );
  });

  return features;
};

const WhyUs = () => {
  return (
    <section className="section why-choose-us">
      <div className="shapes-container">
        <div className="pattern pattern-dots" />
      </div>

      <div className="container pb-8 bring-to-front">
        <div className="section-heading text-center">
          <h2 className="heading-line">Why you should choose Morph?</h2>
          <p className="text-muted lead mx-auto">
            We are Artists first, technical juggarnauts second, let us help showcase your project by leveraging our techincal skills to create unique, memorable & collectable experiences.
          </p>
        </div>

        <div className="row gap-y">
          <div className="col-md-6">
            <h4 className="bold text-alternate">
              It all start by choosing the right team
            </h4>
            <p className="text-muted lead mb-5">
              When you're looking for a platform that helps you stand-out. Morph
              offers many customizable components to help you do just that.
            </p>

            <ul className="list-unstyled why-icon-list">{renderFeatures()}</ul>

            <hr className="my-5" />
            {/* <div className="text-center text-md-left">
              <Link to="#!" className="btn btn-primary text-contrast">
                Know More
              </Link>
            </div> */}
          </div>

          <div className="col-md-6">
            <div className="rotated-mockups device-twin">
              {/* <div className="browser absolute shadow-lg">
                <img
                  src={require("assets/img/screens/tablet/1.png")}
                  alt="..."
                />
              </div> */}

              <div className="front iphone light">
                <div className="screen">
                  <img
                    src={require("assets/img/screens/app/Morph1.png")}
                    alt="..."
                  />
                </div>

                <div className="notch" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
